import styles from "./Footer.module.css";
import logo from "../../assets/logo2.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faLocationDot } from "@fortawesome/free-solid-svg-icons";
import {
    faFacebookF,
    faInstagram,
    faYoutube,
    faLinkedin,
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
    return (
        <footer className={styles.footer}>

            {/* ================= TOP SECTION ================= */}
            <div className={styles.topSection}>

                {/* LEFT: LOGO */}
                <div className={styles.logoBlock}>
                    <img src={logo} alt="Dimora Logo" />

                    <div className={styles.socialIcons}>
                        <div onClick={() => window.open("https://www.facebook.com/100075681507650/ad_center/ ")} className={styles.icon}><FontAwesomeIcon icon={faFacebookF} /></div>
                        {/* <div className={styles.icon}><FontAwesomeIcon icon={faTwitter} /></div> */}
                        <div onClick={() => window.open("https://www.instagram.com/dimora.pune/?hl=en")} className={styles.icon}><FontAwesomeIcon icon={faInstagram} /></div>
                        <div onClick={() => window.open("https://www.youtube.com/@dimorapune")} className={styles.icon}><FontAwesomeIcon icon={faYoutube} /></div>
                        <div onClick={() => window.open("https://www.linkedin.com/company/di-mora")} className={styles.icon}><FontAwesomeIcon icon={faLinkedin} /></div>
                    </div>
                </div>

                {/* CENTER: OPEN + LOCATION (STACKED) */}
                <div className={styles.centerBlock}>

                    {/* OPEN HOURS */}
                    <div className={styles.infoItem}>
                        <div className={styles.iconTitle}>
                            <FontAwesomeIcon icon={faClock} className={styles.greenIcon} />
                            <h4>OPEN HOURS</h4>
                        </div>
                        <p>Wednesday - Sunday from 7:00 pm – 1:30 am</p>
                    </div>

                    {/* LOCATION BELOW */}
                    <div className={styles.infoItem}>
                        <div className={styles.iconTitle}>
                            <FontAwesomeIcon icon={faLocationDot} className={styles.greenIcon} />
                            <h4>LOCATION</h4>
                        </div>
                        <p>Unit No 10, The Mills Sai Radhe Road, Raja Bahadur Motilal Rd, behind Sheraton Grand Pune Bund Garden Hotel, Pune, Maharashtra 411001</p>
                    </div>

                </div>

                {/* RIGHT: OTHER BRANDS */}
                {/* <div className={styles.infoBlock}>
                    <h4>Other Brands</h4>
                    <ul className={styles.brandList}>
                        <li>
                            <a
                                href="https://maps.app.goo.gl/q65uHycU5YHEaiqs7"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.mapLink}
                            >
                                <FontAwesomeIcon icon={faLocationDot} className={styles.greenIcon} />
                                Baglami, Mumbai
                            </a>
                        </li>

                        <li className={styles.lacena}>
                            <a
                                href="https://maps.app.goo.gl/GJigiet89rbqQBmL7"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.mapLink}
                            >
                                <FontAwesomeIcon icon={faLocationDot} className={styles.greenIcon} />
                                La Cena, Thane
                            </a>
                        </li>

                        <li>
                            <a
                                href="https://www.instagram.com/ignitewithblaze/?hl=en"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.mapLink}
                            >
                                <FontAwesomeIcon icon={faLocationDot} className={styles.greenIcon} />
                                Blaze, Pune
                            </a>
                        </li>
                    </ul>

                </div> */}




                <div className={styles.infoBlock}>
                    <h4>Quick Links</h4>
                    <ul className={styles.brandList}>
                        <li>
                            <a
                                href="about"
                                className={styles.mapLink}
                            >
                                About
                            </a>
                        </li>

                        <li className={styles.lacena}>
                            <a
                                href="events"
                                className={styles.mapLink}
                            >
                                Events
                            </a>
                        </li>

                        <li>
                            <a
                                href="menu"
                                className={styles.mapLink}
                            >
                                Menu
                            </a>
                        </li>
                        <li>
                            <a
                                href="careers"
                                className={styles.mapLink}
                            >
                                Careers
                            </a>
                        </li>
                        <li>
                            <a
                                href="contact"
                                className={styles.mapLink}
                            >
                                Contact
                            </a>
                        </li>
                    </ul>

                </div>

            </div>

            <div className={styles.divider}></div>

            {/* BRAND LOGOS */}
            {/* <div className={styles.brandRow}>
                <img src={baglami} alt="Baglami" />
                <img src={lacena} alt="La Cena" />
                <img src={blaze} alt="Blaze" />
            </div> */}

            <div className={styles.divider}></div>

            {/* BOTTOM */}
            <div className={styles.bottom}>
                © 2026 Dimora. All rights reserved.
                {/* <span onClick={()=> window.open('https://pub-dc5215774265416a9110e4c88aef9f9d.r2.dev/imps/Dimora%20Policy.pdf')}>Terms & Conditions</span>  */}
                <a className={styles.privacyPolicy} href="/Dimora-Policy.pdf" target="_blank" rel="noopener noreferrer">
                    Terms and Conditions
                </a>
                {/* <span>Privacy Policy</span> */}
            </div>

        </footer>
    );
};

export default Footer;
